import { ContainerCardConfig } from "./localStyle";

const CardConfig = ({ handleKeyUp, state, onchange, onclick }) => {
  return (
    <ContainerCardConfig>
      <h1>Configuración</h1>
      <h2>Ingresá tu el id terminal</h2>
      {/* Input controlado: si no hay onchange, es readOnly (se usa teclado virtual) */}
      <input
        type="text"
        placeholder="Ej: TAG98"
        onChange={onchange}
        value={state}
        onKeyDown={handleKeyUp}
        autoFocus={true}
        readOnly={!onchange}
      />
      <button onClick={onclick}>Ingresa</button>
    </ContainerCardConfig>
  );
};

export default CardConfig;
